import * as React from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { convertToRuFormat } from "../../../utilits/helpers/convertDateFormat";
import { useGetNomenklatursQuery } from "../../../store/nomenklaturaApi";

function Row({ row }) {
  const [openFirst, setOpenFirst] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpenFirst(!openFirst)}
          >
            {openFirst ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.attributes.name}
        </TableCell>
        <TableCell align="center">
          {row.attributes.address + " " + row.attributes.addressNumber}
        </TableCell>
        <TableCell align="center">{row.attributes.inventNumber}</TableCell>
        <TableCell align="center">{row.attributes.square} кв.м.</TableCell>
        <TableCell
          align="center"
          sx={{ color: row.attributes.dogovor.data.length ? "red" : "green" }}
        >
          {row.attributes.dogovor.data.length ? "Занят" : "Свободeн"}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={openFirst} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                {row.attributes.dogovor.data.length
                  ? "Договор"
                  : "Договор не заключён"}
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Контрагент</TableCell>
                    <TableCell>Договор</TableCell>
                    <TableCell>Дата начало</TableCell>
                    <TableCell>Дата конец</TableCell>
                    <TableCell>Лицевой счет</TableCell>
                    <TableCell>Сумма</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      {row.attributes.dogovor.data[0]?.attributes.contragent
                        ? row.attributes.dogovor.data[0]?.attributes.contragent
                            .data[0]?.attributes.surname +
                          " " +
                          row.attributes.dogovor.data[0]?.attributes.contragent
                            .data[0].attributes.name +
                          " " +
                          row.attributes.dogovor.data[0]?.attributes.contragent
                            .data[0]?.attributes.lastname
                        : ""}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.attributes.dogovor.data.length
                        ? "№" + row.attributes.dogovor.data[0].attributes.numberDogovor
                        : ""}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.attributes.dogovor.data.length
                        ? convertToRuFormat(
                            row.attributes.dogovor.data[0]?.attributes
                              .dateDogovorFrom
                          )
                        : ""}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.attributes.dogovor.data.length
                        ? convertToRuFormat(
                            row.attributes.dogovor.data[0]?.attributes
                              .dateDogovorTo
                          )
                        : ""}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.attributes.dogovor.data[0]?.attributes.invoice}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.attributes.dogovor.data[0]?.attributes.totalSum}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default function CollapsibleTable() {
  const [sort, setSort] = React.useState("id");
  const { data: nomenklatursFB } = useGetNomenklatursQuery(
    `?sort[0]=${sort}:desc&populate[1]=dogovor&populate[2]=dogovor.contragent`
  );
  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    const setDataToStates = async () => {
      try {
        const nomenklaturs = await nomenklatursFB.data;
        setRows(nomenklaturs);
      } catch (error) {}
    };
    setDataToStates();
  }, [nomenklatursFB]);

  const filteredRows = rows.map((row) => {
    const filteredRow = row.attributes.dogovor.data.filter(
      (dogovor) => new Date(dogovor.attributes.dateDogovorTo) > new Date()
    );
  
    // Сортировка под массива договор: сначала пустые массивы, затем непустые
    filteredRow.sort((a, b) => {
      if (a.length === 0 && b.length === 0) return 0;
      if (a.length === 0) return -1;
      if (b.length === 0) return 1;
      return 0;
    });
  
    return {
      ...row,
      attributes: { ...row.attributes, dogovor: { data: filteredRow } },
    };
  }).sort((a, b) => {
    // Сортировка основного массива по длине отфильтрованных под массивов
    return a.attributes.dogovor.data.length - b.attributes.dogovor.data.length;
  });
  
  return (
    <>
      <div style={{ margin: "20px 0 20px 20px" }}>
        <Typography variant="h5" gutterBottom component="div">
          Сформирован на: {convertToRuFormat(new Date())}
        </Typography>
      </div>
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>
                <Typography variant="h5" gutterBottom component="div">
                  Номенклатура
                </Typography>
              </TableCell>
              <TableCell
                align="center"
                onClick={() => setSort("address")}
                sx={{ cursor: "pointer" }}
              >
                <Typography variant="h5" gutterBottom component="div">
                  Адрес
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="h5" gutterBottom component="div">
                  Идентификационный код
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="h5" gutterBottom component="div">
                  Площадь
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="h5" gutterBottom component="div">
                  Состояние
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredRows.map((row) => (
              <Row key={row.id} row={row} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
